// extracted by mini-css-extract-plugin
export var fullGrid = "_31-3";
export var pdpPreviewContainer = "_31-1";
export var previewContainer = "_31-0";
export var togglePreviewContainer = "_31-2";